import { render } from "./UserEndQuizComponent.vue?vue&type=template&id=48e4261c"
import script from "./UserEndQuizComponent.vue?vue&type=script&lang=js"
export * from "./UserEndQuizComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apiffare/projects/norbert-weston/norbert-weston-1/apps/norbert-weston-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__